<template>
  <mdc-dialog v-model="isOpen"
              :title="'user.confirm_delete_title' | trans"
              :accept="'user.delete' | trans"
              :cancel="'user.cancel' | trans"
              @accept="accept" @cancel="cancel">
    {{'user.confirm_delete_client_form_therapist' | trans}}
  </mdc-dialog>
</template>

<script>
  export default {
    name: 'ConfirmDeleteModal',
    props: {
      visible: {
        required: true,
        types: [Boolean],
      },
      item: {
        required: true,
        types: [Object],
      }
    },
    computed: {
      isOpen: {
        get: function () {
          return this.visible
        },
        set: function () {},
      },
    },
    methods: {
      accept: function () {
        this.$emit('accept', this.item)
      },
      cancel: function () {
        this.$emit('cancel', this.item)
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/modules/protocols/components/ConfirmModal.vue